// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import echarts from 'echarts';
import axios from 'axios';
import { Message } from 'element-ui';
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.prototype.$http = axios;
Vue.prototype.$message = Message;
Vue.prototype.$echarts = echarts;
axios.defaults.headers.common['token'] = store.state.token;
/* eslint-disable no-new */
window.Promise = Promise

// 添加请求拦截器
axios.interceptors.request.use(config => {
// 在发送请求之前做些什么
//判断是否存在token，如果存在将每个页面header都添加token
  if(store.state.token){
    config.headers.common['token']=store.state.token
  }

  return config;
}, error => {
// 对请求错误做些什么
  return Promise.reject(error);
});

// http response 拦截器
axios.interceptors.response.use(
  response => {
    if (response.data.status === 999997 || response.data.status === 999998) {
      const message_conf = {
        showClose: true,
        message: 'token失效请重新登陆...',
        type: 'error',
        duration: 2000
      }
      Message(message_conf)

      sessionStorage.removeItem('token'); // 删除已经失效或过期的token（不删除也可以，因为登录后覆盖）

      router.replace({

        path: '/' // 到登录页重新获取token

      })

    }
    return response;
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          this.$store.commit('del_token');
          router.replace({
            path: '/',
            query: {redirect: router.currentRoute.fullPath}//登录成功后跳入浏览的当前页面
          })
      }
    }
    return Promise.reject(error.response.data)
  });

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js